import React, { Component } from 'react';
import Modal from '../components/Modal';
import StagesManager from '../components/StagesManager';
import ButtonAnimated from '../components/buttons/ButtonAnimated';
import FixedView from '../components/FixedView';
import { checkTranslation, translate } from '../utils/useful';
import ActionButton from '../components/partials/ActionButton';
import SideActionsList from '../components/SideActionsList';
import RemoveConfirmationModal from './RemoveConfirmationModal';
import CustomLoader from '../components/CustomLoader';
import AddWorkflowFromApplet from '../components/AddWorkflowFromApplet';
import HttpServices from '../utils/Http.services';
import store from '../stores/storeConfig';
import { addNotif } from '../stores/actionsList';

class FrameAutomationsModal extends Component {

    state = {

    }

    componentDidMount() {

    }


    componentDidUpdate(prevProps) {

    }


    submit = () => {
        this.modal.hideModal()
    }


    open = () => {
        this.modal.showModal()
        this.init()

    }


    init = () => {
        // console.log('firstllll', this.porps)
        this.setState({ isLoading: true })
        let body = { frame: this.props.frame._id }
        // TO DO: fetch 
        HttpServices.request('getFrameAutomations', body, (fetchResult, fetchError) => {
            if (fetchError || !fetchResult?.info) {
                store.dispatch(addNotif({ type: 'error', title: '{{lang}}errors.TypeRequired', description: translate("") }))
                return
            }
            this.setState({ automations: fetchResult.info.automations, workflows: fetchResult.info.workflow }, () => {

                this.setState({ isLoading: false }, () => {
                    setTimeout(() => {
                        this.setState({ showFixed: true })
                    }, 10);
                })

            })
        })

    }


    fetchRemove = () => {

    }

    openRemoveModal = (action) => {
        this.removeModal.modal.showModal()
        this.setState({ currentAction: action })
    }

    goToEdit = (data) => {
        
        this.props.functionsHandler('admin', 'changePage', ['settings', 'automations', data._id])

    }

    addWorkFlow = (mode) => {
        this.props.functionsHandler('admin', 'changePage', ['settings', 'automations', 'new'], { frame: this.props.frame?._id, mode, type: 'workflow' })
    }

    addAutomation = () => {
        this.props.functionsHandler('admin', 'changePage', ['settings', 'automations', 'new'], { frame: this.props.frame?._id, type: 'automation' })
    }



    render() {

        let colors = this.props.colors


        return (

            <>
                <Modal maxWidth={400} ref={(el) => this.modal = el} zIndex={10}>
                    <div className="w-100 br-10" style={{ backgroundColor: "#fff", overflow: 'hidden' }} >
                        <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >
                            <div className="" stage={0} stageName={'init'}>
                                <div className='pb-5'>
                                    <div className="pb-1 pt-1 px-3  flexcb top-0" style={{ position: 'sticky', backgroundColor: '', borderBottom: '1px solid #eee' }}>
                                        <p className="mt-0 text-normal text-bold">{translate('Frame Automations')}</p>

                                        <ButtonAnimated
                                            // iconwidth='24px'
                                            onClick={() => { this.submit() }}
                                            title={translate('Submit')}
                                            icon='/assets/icons/arrow-right-white.svg'
                                            textColor={this.props.colors?.textColor}
                                            invert={this.props.colors?.iconInvert}
                                            bg={this.props.colors?.background}
                                            isLoading={this.state.isLoadingPost}
                                        />
                                    </div>

                                    {this.state.isLoading && (
                                        <div className='pt-4'>
                                            <CustomLoader isLoading={true} />
                                        </div>
                                    )}

                                    {!this.state.isLoading && (
                                        <div>
                                            <div className='px-3 pt-2 mt-1'>

                                                <div className='mb-2 '>
                                                    <div className='flexcb'>
                                                        <p className='text-bold text-small mb-1'>{translate("Workflows")}</p>
                                                        <button onClick={(e) => { e.stopPropagation(); this.plusFixedView.showView() }} ref={el => this.plusBut = el} className='text-link br-4 px-0 py-1' style={{ border: '0px solid #007aff', whiteSpace: 'nowrap' }}>
                                                            <p>{translate("+ Add workflow")}</p>
                                                        </button>
                                                    </div>

                                                    <div className=' '>
                                                        <p className=' text-smaller mrd-4'>{translate("Each record can follow just one workflow")}</p>
                                                    </div>
                                                </div>

                                                {this.state.showFixed && (
                                                    <FixedView width={this.props.width} zIndex={10} ref={el => this.plusFixedView = el} nodeRef={this.plusBut} xOffset={-7} bottomOffset={this.props.fullSize ? -7 : 0} topOffset={this.props.fullSize ? -30 : 0} maxWidth={220} >
                                                        <div className='bg-white br-10 py-3 px-3 shadow-3 sc-gray2 d-flex flex-column'>

                                                            <button onClick={() => this.addWorkFlow('basic')} className='text-link text-start br-4 px-0 py-1 ' style={{ border: '0px solid #007aff' }}>
                                                                <p>{translate("+ Add a basic workflow")}</p>
                                                            </button>
                                                            <p className='text-smallest color-gray-2 mb-1'>{translate("Normal workflows are the easy way to create simple workflows with don't need conditions or other automation in it.")}</p>

                                                            <button onClick={() => this.addWorkFlow('advanced')} className='text-link text-start br-4 px-0 py-1' style={{ border: '0px solid #007aff' }}>
                                                                <p>{translate("+ Add an advance workflow")}</p>
                                                            </button>
                                                            <p className='text-smallest color-gray-2 mb-1'>{translate("Advanced workflows are good when you want to create conditions foe flows or you want to combine the workflow with other automations.")}</p>


                                                            <button onClick={() => { this.plusFixedView.hideView(); this.addWorkflowFromApplet.open() }} className='text-link text-start br-4 px-0 py-1' style={{ border: '0px solid #007aff' }}>
                                                                <p>{translate("+ Add from applet workflows")}</p>
                                                            </button>
                                                            <p className='text-smallest color-gray-2 mb-0'>{translate("You can add workflow from current available and accessable applet workflows.")}</p>

                                                        </div>
                                                    </FixedView>
                                                )}

                                                <div className='px-0'>

                                                    {this.state.workflows?.length == 0 && (
                                                        <div className='text-center px-2 py-3 br-4 mt-2' style={{ border: '1px solid #f0f0f0' }}>
                                                            <p className='text-semibold text-small'>{translate("No workflow found")}</p>
                                                            <p className=' text-smaller color-gray-2'>{translate("Workflow option is not activated for this frame yet. You can add a workflow to activate this option.")}</p>

                                                        </div>
                                                    )}

                                                    {this.state.workflows?.map((action, index) => {
                                                        return (
                                                            <div key={index} className='pt-2 pb-2' style={{ borderBottom: '1px solid #f2f2f2' }}>
                                                                <WorkflowRow data={action} openRemoveModal={this.openRemoveModal} goToEdit={this.goToEdit} />
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>




                                            <div className='px-3 pt-4'>

                                                <div className='mb-2 '>
                                                    <div className='flexcb'>
                                                        <p className='text-bold text-small mb-1'>{translate("Automations")}</p>
                                                        <button onClick={(e) => { this.addAutomation() }} className='text-link br-4 px-0 py-1' style={{ border: '0px solid #007aff', whiteSpace: "nowrap" }}>
                                                            <p>{translate("+ Add automation")}</p>
                                                        </button>
                                                    </div>

                                                    <div className=' '>
                                                        <p className=' text-smaller mrd-4'>{translate("List of the automations which are related to this frame.")}</p>
                                                    </div>
                                                </div>

                                                <div className='px-0'>
                                                    {this.state.automations?.map((action, index) => {
                                                        return (
                                                            <div key={index} className='pt-2 pb-2' style={{ borderBottom: '1px solid #f2f2f2' }}>
                                                                <AutomationRow data={action} openRemoveModal={this.openRemoveModal} goToEdit={this.goToEdit} />
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>


                                        </div>

                                    )}
                                </div>
                            </div>
                        </StagesManager>
                    </div>

                </Modal>



                <Modal width={this.props.width} maxWidth={400} zIndex={40} ref={el => this.addActionModal = el} >
                    <div className={'h-100 scroll-no-scrollbar pb-5 br-8 '} style={{ backgroundColor: '#fff', }}>
                        <SideActionsList functionsHandler={this.functionsHandler} setAddViewLoading={this.setAddViewLoading} isLoadingView={this.state.isLoadingView} background={colors?.background} page={this.props.page} variables={this.state.variables ?? this.props.variables} closeAddView={this.closeAddView} frame={this.props.page} setData={this.props.setData} changeSidebar={this.changeSidebar} headers={this.props.headers} params={this.props.params} />
                    </div>
                </Modal>


                <AddWorkflowFromApplet initData={this.props.initData} ref={el => this.addWorkflowFromApplet = el} functionsHandler={this.functionsHandler} setAddViewLoading={this.setAddViewLoading} isLoadingView={this.state.isLoadingView} background={colors?.background} page={this.props.page} variables={this.state.variables ?? this.props.variables} closeAddView={this.closeAddView} frame={this.props.page} setData={this.props.setData} changeSidebar={this.changeSidebar} headers={this.props.headers} params={this.props.params} />


                <RemoveConfirmationModal ref={el => this.removeModal = el} confirmed={this.fetchRemove} />


            </>
        )
    }
}




class WorkflowRow extends Component {

    state = {
        modeTitle: {
            advanced: '{{lang}}Advanced',
            basic: '{{lang}}Basic',
        }
    }
    render() {


        return (
            <div className='flexc'>
                <div className='flexcc'>

                    <ActionButton>
                        <div className="  pt-2 pb-2 px-3 d-flex flex-column w-100" style={{ minWidth: 180, boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 6 }}>


                            <button className="w-100 p-0 text-start flexc mt-1 mb-1" onClick={() => this.props.goToEdit(this.props.data)}>
                                <img src='/assets/icons/useful/edit.png' height={15} alt='' />
                                <p className="text-smaller text-semibold px-1  ">{translate('View / Edit')}</p>

                            </button>


                            <button className="w-100 p-0 text-start flexc mt-1 mb-1" onClick={() => this.props.goToEdit(this.props.data)}>
                                <img src='/assets/icons/useful/star (9).png' height={15} alt='' />
                                <p className="text-smaller text-semibold px-1  ">{translate('Make as default')}</p>
                            </button>

                            <button className="w-100 p-0 text-start flexc mt-1 mb-1" onClick={() => this.props.goToEdit(this.props.data)}>
                                <img src='/assets/icons/useful/directions.png' height={15} alt='' />
                                <p className="text-smaller text-semibold px-1  ">{translate('Convert to advance')}</p>
                            </button>

                            {/* <button className="w-100 p-0 text-start flexc mt-1 mb-1" onClick={() => this.props.goToEdit(this.props.data)}>
                                <img src='/assets/icons/useful/edit.png' height={15} alt='' />
                                <p className="text-smaller text-semibold px-1  ">{translate('Edit')}</p>

                            </button> */}

                            <button className="w-100 p-0 text-start flexc mt-1 mb-1" onClick={() => this.props.openRemoveModal(this.props.data)} >
                                <img src='/assets/icons/useful/trash.png' height={15} alt='' />
                                <p className="text-smaller text-semibold px-1  ">{translate('Remove')}</p>

                            </button>

                        </div>
                    </ActionButton>

                </div>
                <div className='mld-2 flexcb w-100'>
                    <div className='flexc'>
                        <p className='text-small text-semibold'>{checkTranslation(this.props.data?.name)}</p>
                        {/* <p className='text-smaller'>{this.props.data?.type}</p> */}
                    </div>

                    <div className='flexc'>

                        {/* <div className=' p-1 mld-0 flexcc ' style={{ opacity: 0.3 }}>
                            <img src={'/assets/icons/useful/padlock.png'} width={14} />
                        </div> */}

                        <div className='br-20 mld-2 px-2 py-1 text-smallest text-semibold  white' style={{ background: "rgb(88, 86, 214)" }}>{translate("Default")}</div>
                        <div className='br-20 mld-2 px-2 py-1 text-smallest text-semibold ' style={{ background: "rgb(253, 216, 54)" }}>{translate(this.state.modeTitle[this.props.data?.mode])}</div>

                    </div>

                </div>




            </div>
        )
    }

}






class AutomationRow extends Component {


    render() {


        return (
            <div className='flexc'>
                <div className='flexcc'>

                    <ActionButton>
                        <div className="  pt-2 pb-2 px-3 d-flex flex-column w-100" style={{ minWidth: 180, boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 6 }}>


                            <button className="w-100 p-0 text-start flexc mt-1 mb-1" onClick={() => this.props.goToEdit(this.props.data)}>
                                <img src='/assets/icons/useful/edit.png' height={15} alt='' />
                                <p className="text-smaller text-semibold px-1  ">{translate('View / Edit')}</p>

                            </button>


                            <button className="w-100 p-0 text-start flexc mt-1 mb-1" onClick={() => this.props.openRemoveModal(this.props.data)} >
                                <img src='/assets/icons/useful/trash.png' height={15} alt='' />
                                <p className="text-smaller text-semibold px-1  ">{translate('Remove')}</p>

                            </button>

                        </div>
                    </ActionButton>

                </div>
                <div className='mld-2 flexcb w-100'>
                    <div className='flexc'>
                        <p className='text-small text-semibold'>{checkTranslation(this.props.data?.name)}</p>
                    </div>

                    {/* <div className='flexc'>


                        <div className='br-20 mld-2 px-2 py-1 text-smallest text-semibold  white' style={{ background: "rgb(88, 86, 214)" }}>{translate("Default")}</div>
                        <div className='br-20 mld-2 px-2 py-1 text-smallest text-semibold ' style={{ background: "rgb(253, 216, 54)" }}>{translate("Advanced")}</div>

                    </div> */}

                </div>




            </div>
        )
    }

}


export default FrameAutomationsModal;